<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">User List</h5>
     <br/>
     <br/>

     <div class="row">
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Username</label>
        <input [(ngModel)]="Filter_Username" (keyup)="Change_Filter()" name="Filter_title" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1"> Name </label>
        <input [(ngModel)]="Filter_Name" (keyup)="Change_Filter()" name="Filter_title" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1"> Last Name </label>
        <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_title" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_User()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button *ngIf="!Procssing" routerLink="/UserAdd" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add New Record </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Last Name</th>
              <th>User Type</th>
              <th>Username</th>
              <th>Created By</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_User
            |filter:Filter_Name:'name'
            |filter:Filter_Familly:'familly'
            |filter:Filter_Username:'username'
            | paginate
                    : {
                        id: 'DataList_UserTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_User
                        |filter:Filter_Name:'name'
                        |filter:Filter_Familly:'familly'
                        |filter:Filter_Username:'username'
                        ).length
                      }
            ">
             <td>{{DataList_User.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td>{{item.username}}</td>
              <td>{{item.type_title}}</td>
              <td>{{item.creater}}</td>
              <td>{{item.persianDate}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" class="dropdown-item" (click)="AutoLogin(item)" ><i class="fa fa-lock"></i> Sign In as User </a>
                          <a class="dropdown-item" [routerLink]="['/UserEdit',{id:item.id}]"><i class="fa fa-edit"></i> Edit </a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> Delete </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_UserTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Approve Delete User '{{Data_Seleted_Delete.username}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> Delete <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
